module.exports = __webpack_public_path__ + "img/025-anguilla.b420683b.svg";